<template>
  <AppDialog
    title="Are you sure you want to merge?"
    size="large"
    show
    append-to-body
    data-testid="merge-dialog"
    @close="$emit('cancel')"
  >
    <p class="text-grey font-weight-normal mb-20">
      This action cannot be undone. Duplicate profile data will be overwritten by the main member profile's data.
    </p>
    <div class="d-flex gap-10 gap-sm-60">
      <div class="flex">
        <h6 class="small text-lighter mb-5">Duplicate member</h6>
        <div
          class="border-rounded px-15 d-inline-flex gap-10 border-solid py-10"
          data-testid="merge-dialog-duplicate"
        >
          <HubAvatar
            :user-id="duplicate.user.id"
            avatar-style="medium"
            class="hidden-xs"
            :users-avatars="usersAvatars"
          />
          <div class="text-left">
            <div
              class="font-weight-bold"
              data-testid="merge-dialog-duplicate-name"
            >
              {{ duplicate.user.name }}
            </div>
            <div class="small text-lighter">{{ duplicateOsUsername }}</div>
            <div class="small text-lighter">{{ duplicate.user.email }}</div>
            <div class="small text-lighter">{{ duplicate.member_type }} member</div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-center">
        <i class="hi hi-right-arrow hi-16 text-lighter"></i>
      </div>

      <div class="flex">
        <h6 class="small text-lighter mb-5">Main member</h6>
        <div
          class="border-rounded px-15 d-inline-flex gap-10 border-solid py-10"
          data-testid="merge-dialog-main"
        >
          <HubAvatar
            :user-id="main.user.id"
            avatar-style="medium"
            class="hidden-xs"
            :users-avatars="usersAvatars"
          />
          <div class="text-left">
            <div
              class="font-weight-bold"
              data-testid="merge-dialog-main-name"
            >
              {{ main.user.name }}
            </div>
            <div class="small text-lighter">{{ mainOsUsername }}</div>
            <div class="small text-lighter">{{ main.user.email }}</div>
            <div class="small text-lighter">{{ main.member_type }} member</div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="main.main_pending_merges_count > 0"
      class="alert alert-warning mt-20"
    >
      <div class="d-flex align-items-center gap-10 mb-5">
        <i class="hi hi-warning" />
        <h6>Merge with main member already in progress</h6>
      </div>
      <div>
        There {{ main.main_pending_merges_count === 1 ? 'is' : 'are' }}
        {{ main.main_pending_merges_count }} {{ main.main_pending_merges_count | pluralize('merge') }} already queued for this main member.
        This merge will start once the pending {{ main.main_pending_merges_count | pluralize('merge') }}
        complete{{ main.main_pending_merges_count === 1 ? 's' : '' }}.
      </div>
    </div>

    <template #footer>
      <AppButton
        data-testid="merge-dialog-cancel"
        @click="$emit('cancel')"
      >
        Cancel
      </AppButton>
      <AppButton
        type="primary"
        data-testid="merge-dialog-confirm"
        @click="$emit('confirm')"
      >
        Confirm merge
      </AppButton>
    </template>
  </AppDialog>
</template>

<script>
import { createUsersAvatarsMixin } from '~/mixins/UsersAvatarsMixin';

export default {
  name: 'ClientAgentMergeConfirmDialog',
  mixins: [createUsersAvatarsMixin('avatarUsers')],
  props: {
    duplicate: {
      type: Object,
      required: true
    },
    main: {
      type: Object,
      required: true
    },
  },
  computed: {
    duplicateOsUsername() {
      return this.duplicate?.client_agent?.os_username || this.duplicate?.os_username || '';
    },
    mainOsUsername() {
      return this.main?.client_agent?.os_username || this.main?.os_username || '';
    },
    avatarUsers() {
      const arr = [];

      if (this.duplicate?.user?.avatar_url) {
        arr.push({ id: this.duplicate.user.id, avatar: this.duplicate.user.avatar_url });
      }
      if (this.main?.user?.avatar_url) {
        arr.push({ id: this.main.user.id, avatar: this.main.user.avatar_url });
      }

      return arr;
    },
  },
};
</script>
